import {
  Bell,
  BarChart3,
  FileText,
  History,
  Home,
  MapPin,
  Receipt,
  Route,
  Settings,
  ShieldCheck,
  Truck,
  UserRound,
  Users,
  Wrench,
  type LucideIcon,
} from 'lucide-react';

export interface NavItem {
  to: string;
  labelKey: string;
  icon: LucideIcon;
  /** Permission needed to see this item (M1). */
  permission?: string;
  badgeKey?: 'pendingExpenses' | 'openAlerts';
  end?: boolean;
}

export const NAV_ITEMS: NavItem[] = [
  { to: '/', labelKey: 'nav.dashboard', icon: Home, permission: 'dashboard:read', end: true },
  { to: '/live', labelKey: 'nav.live', icon: MapPin, permission: 'live:read' },
  { to: '/history', labelKey: 'nav.history', icon: History, permission: 'history:read' },
  { to: '/trips', labelKey: 'nav.trips', icon: Route, permission: 'trips:read' },
  { to: '/vehicles', labelKey: 'nav.vehicles', icon: Truck, permission: 'vehicles:read' },
  { to: '/drivers', labelKey: 'nav.drivers', icon: UserRound, permission: 'drivers:read' },
  { to: '/customers', labelKey: 'nav.customers', icon: Users, permission: 'customers:read' },
  { to: '/places', labelKey: 'nav.places', icon: MapPin, permission: 'places:read' },
  { to: '/expenses', labelKey: 'nav.expenses', icon: Receipt, permission: 'expenses:read', badgeKey: 'pendingExpenses' },
  { to: '/maintenance', labelKey: 'nav.maintenance', icon: Wrench, permission: 'maintenance:read' },
  { to: '/invoices', labelKey: 'nav.invoices', icon: FileText, permission: 'invoices:read' },
  { to: '/reports', labelKey: 'nav.reports', icon: BarChart3, permission: 'reports:read' },
  { to: '/alerts', labelKey: 'nav.alerts', icon: Bell, permission: 'alerts:read', badgeKey: 'openAlerts' },
  { to: '/settings', labelKey: 'nav.settings', icon: Settings, permission: 'settings:read' },
];

export const ADMIN_NAV: NavItem = { to: '/admin', labelKey: 'nav.admin', icon: ShieldCheck };
